import React from 'react'
import styled from 'styled-components'

const withDefaultStyles = (Component) => (props) => (
  <IconContainer {...props}>
    <Component {...props} />
  </IconContainer>
)

const IconContainer = styled.div.attrs((props) => ({
  id: props.id || 'icon-container',
}))`
  display: inline-flex;
  align-items: center;
  width: fit-content;

  ${({ onClick }) => onClick && 'cursor: pointer;'}

  ${({ spin }) =>
    spin &&
    `
    animation-name: spin;
    animation-duration: 3000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes spin {
      from {
          transform:rotate(0deg);
      }
      to {
          transform:rotate(360deg);
      }
    }
  `}

  svg {
    width: ${({ width }) => width || '24px'};
    height: ${({ height }) => height || '24px'};
    color: ${({ fill, noDefaultFill }) => fill || (!noDefaultFill && 'var(--ds-gray-2)')};
  }

  svg,
  svg > path,
  svg > line {
    width: ${({ width }) => width || '24px'};
    height: ${({ height }) => height || '24px'};
    fill: ${({ fill, noDefaultFill }) => fill || (!noDefaultFill && 'var(--ds-gray-2)')};
  }

  &:hover {
    svg {
      color: ${(props) => (props.hoverFill ? props.hoverFill : props.fill)};
    }

    svg,
    svg > path,
    svg > line {
      fill: ${(props) => (props.hoverFill ? props.hoverFill : props.fill)};
    }
  }
  ${({ background }) =>
    background &&
    `
    position: relative;
    &:before {
      position: absolute;
      content: '';
      border-radius: 50%;
      background: ${background};
      opacity: 0.1;
      height: 100%;
      width: 100%;
      box-sizing: content-box;
      padding: 4px;
      left: 50%;
      translate: -50%;
    }
    `}
`

export default withDefaultStyles
